require('./brokerCreateTransferOfDerivativesStepSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @components
const BrokerTransferOfDerivatives = require('components/broker/brokerTransferOfDerivatives/brokerTransferOfDerivatives');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { FIRST_STEP, BROKER_MYPROFILE_MYWALLET_URL, MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_URL, DATE_FORMAT_DAY_MONTH_YEAR } = require('constants/index');

const BrokerCreateTransferOfDerivativesWizardSuccess = props => {
    const {
        immAccounts,
        immBrokerCreateTransferOfDerivatives,
        immBrokerWallets
    } = props;

    const selectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'selectedOriginDerivative']
    );

    const immOriginFuture = immBrokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === selectedOriginDerivative
    );

    const destinationAccount = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'destinationAccount']
    );

    const immDestinationAccount = immAccounts.get(destinationAccount);

    const originAccountName = immOriginFuture.get('descripcion', '').trim();
    const originAccountNumber = immOriginFuture.getIn(['ibanComplex', 'codbban']);
    const originAccountBalance = immOriginFuture.getIn(['saldoActual', 'importe']);
    const originAccountBalanceCurrency = immOriginFuture.getIn(['saldoActual', 'divisa']);

    const destinationAccountName = immDestinationAccount.get('description', '').trim();
    const destinationAccountNumber = immDestinationAccount.getIn(['ibanComplex', 'codbban']);
    const destinationAccountBalance = immDestinationAccount.getIn(['balance', 'amount']);
    const destinationAccountBalanceCurrency = immDestinationAccount.getIn(['balance', 'currency']);

    const amountToTransfer = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'amount']
    );
    const amountToTransferCurrency = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'amountCurrency']
    );

    const successMessage = formatText('broker-transferOfDerivativesCreateSuccessTitle');
    const mainButton = {
        label: formatText('broker-transferOfDerivativesCreateGoToMyWallet'),
        url: BROKER_MYPROFILE_MYWALLET_URL,
        modifier: 'secondary'
    };
    const secondaryButton = {
        label: formatText('broker-transferOfDerivativesCreateCheckOrder'),
        url: MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_URL
    };

    const creationDate = immBrokerCreateTransferOfDerivatives.get('creationDate');
    const formatCreationDate = moment(creationDate).format(DATE_FORMAT_DAY_MONTH_YEAR);

    return (
        <WizardSuccess
            mainButton={mainButton}
            secondaryButton={secondaryButton}
            successMessage={successMessage}
        >
            <h4 className="broker-create-transfer-of-derivatives-wizard-success__details-title">
                <FormattedText value="broker-transferOfDerivativesCreateTransactionData"/>
            </h4>
            <div className="row broker-create-transfer-of-derivatives-wizard-success__details-container">
                <div className="col-xs-6">
                    <BrokerTransferOfDerivatives
                        showTitle={false}
                        showCreationDate={false}
                        originAccountName={originAccountName}
                        originAccountNumber={originAccountNumber}
                        originAccountBalance={originAccountBalance}
                        originAccountBalanceCurrency={originAccountBalanceCurrency}
                        destinationAccountName={destinationAccountName}
                        destinationAccountNumber={destinationAccountNumber}
                        destinationAccountBalance={destinationAccountBalance}
                        destinationAccountBalanceCurrency={destinationAccountBalanceCurrency}
                        amountToTransfer={amountToTransfer}
                        amountToTransferCurrency={amountToTransferCurrency}
                    />
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title="broker-transferOfDerivativesCreateDate"
                            bodyText={formatCreationDate}
                            isUppercaseTitle={true}
                        />
                    </OKInformativeList>
                </div>
            </div>
        </WizardSuccess>
    );
};

BrokerCreateTransferOfDerivativesWizardSuccess.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerCreateTransferOfDerivatives: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired
};

module.exports = BrokerCreateTransferOfDerivativesWizardSuccess;